<template>
  <v-app id="app">





     <div class="app-base">
        <div class="app-content">

           <!--<img src="./assets/images/content/banner_top.png" width="100%" class="banner-image" >-->

           <Section background="white"  class="banner-container"
                    :style="{'background-image': `url(${require('./assets/images/content/banner_top2.png')})`}"
           >

              <!--<nav-bar dark></nav-bar>-->
              <!--      <div class=" main-heading heading-line pt-1">-->
              <!--      </div>-->

              <div class="flex-center" style=" width: 100%; height: 100%; justify-content: center" >


                 <div v-if="isJapanese" class="heading-banner-jp">
                    波平ミニストリー　
                    主の来臨に備えて
                 </div>


                 <template v-else>
                    <div class="heading-banner" >Namihira Ministries</div>
                    <div class="" style="font-size: 16pt; margin-left: 250px">Preparing for Jesus' Second Coming</div>
                 </template>

              </div>
           </Section>


           <nav-bar class="nav-bar" dark></nav-bar>
           <router-view></router-view>


        </div>
     </div>



    <!--<div id="main-background-gradient"></div>-->

    <!--add 'app' to nav-bar if the navbar should be fixed at top of page-->
<!--    <nav-bar></nav-bar>-->

    <!-- Sizes your content based upon application components -->
    <!-- <v-content>-->
    <!--    <router-view></router-view>-->
    <!-- </v-content>-->


    <!--add 'app' to footer if the navbar should be fixed at top of page-->
    <v-footer color="#2196F3" >
      <div class="footer">Copyright © 2021</div>
    </v-footer>
  </v-app>







</template>
<script>

import navBar from "@/components/navBar";
import Section from "@/components/Section";

export default {
   name: 'App',
   components: {navBar, Section },
   data: () => ({
      //
   }),

   computed: {
     isJapanese(){
        return this.$store.state.lang === 'jp'
     }
   },


   created(){
      if (this.$route.path.includes('/jp')){
         // console.log('jap version')
         this.$store.commit('update_lang', 'jp')
      }
   }
};
</script>


<style src="./views/base.css"></style>

<style scoped >

   .app-base{
       width: 100%;
       min-height: 100vh;
       display: flex;
       justify-content: center;
       background-color: var(--color-main-bg);
   }

   .app-content{
       width: 100%;
       /*max-width: 1280px;*/
       max-width: 960px;
       background-color: white;

   }

   .banner-image{
       display: block;
   }

   .banner-container{
       background-size: cover;
       background-position: center;
       height: 150px;

   }


   .heading-banner{
       font-family: 'Tangerine', cursive !important;
       font-size: 65pt;
       font-weight: 600;
       margin-bottom: -30px;
   }

   .heading-banner-jp{
       padding-left: 100px;
       font-size: 30pt;
       font-weight: 600;
   }

   .nav-bar{
       margin: 0px 0 0px 0;
   }



  .closing{
    background: rgba(255, 0, 0, 0.55);
    text-align: center;
    font-size: x-large;
  }


  .open{
    background: rgba(123, 255, 83, 0.55);
    text-align: center;
    font-size: large;
  }


  #app{
    background: none;
    //background-color: #EBF5FF;
  }


  #main-container{
    /*background: none;*/
    padding: 0;
  }


  #main-background-gradient{
    position: fixed;
    height: 100%;
    /*min-height: 1000px;*/
    width: 100%;
    margin: 0;

    /*//color: $color-white;*/
    /*background: $color-app-background;*/
    z-index: -1;
    /*opacity: 0.5;*/

  }

  .footer{
    /*background: #2196F3;*/
    text-align: center;
    width:100%;
  }


</style>

